// extracted by mini-css-extract-plugin
module.exports =  {"errorPage":"J5BdAQMZttbwUKYqg3eW","heading":"DP0MZwxDnMtadZ5bVZJv"};